<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Registers</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        <router-link to="/user_checks">Check Registers</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page">View</li>
                </ol>
                <h4 class="main-title mb-0">View Check Register</h4>
            </div>
            <router-link to="/user_checks" type="submit" class="btn btn-primary" style="float: right;">
                <i class="ri-list-check"></i> CHECK REGISTERS
            </router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one mb-3">
                    <div class="card-header">
                        <h5 class="card-title">Check Register</h5>
                        <br />
                    </div>
                    <div class="card-body p-0">
                        <div class="setting-item">
                            <div class="row g-2 mb-4">
                                <div class="col-md-3 mb-3">
                                    <h6>Reference Number</h6>
                                    <p class="font">{{ user_check.reference_no || 'N/A' }}</p>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <h6>Asset Code</h6>
                                    <p class="font">{{ user_check?.asset?.asset_code || 'N/A' }}</p>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <h6>Frequency</h6>
                                    <p class="font">{{ frequencyNames || '' }}</p>
                                </div>
                                <div class="col-md-3 mb-3">
                                    <h6>Reference Date</h6>
                                    <p class="font">{{ convertDateFormat(user_check.reference_date) || 'N/A' }}</p>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <h6>Note</h6>
                                    <p class="font mb-0">{{ user_check.note || '—' }}</p>
                                </div>
                                <div class="col-md-12 mt-1">
                                    <h6 class="mb-2">Asset Checks:</h6>
                                    <div v-if="user_check.asset_checks && user_check.asset_checks.length" class="table-responsive table-responsive-sm">
                                        <table class="table table-responsive table-sm text-nowrap table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">#</th>
                                                    <th class="text-left">Field Name</th>
                                                    <th>Field Type</th>
                                                    <th>Default Value</th>
                                                    <th>Is Required</th>
                                                    <th>Field Values</th>
                                                    <th>LCL</th>
                                                    <th>UCL</th>
                                                    <th>Value</th>
                                                    <th>Check Remark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(frequencyGroup, frequency_id, index) in groupedChecks" :key="frequency_id">
                                                    <tr class="frequency-header">
                                                        <td colspan="10" class="font-weight-bold">{{ frequencyGroup.frequency_name || '' }}</td>
                                                    </tr>
                                                    <template v-for="(check, key) in frequencyGroup.checks" :key="check.check_id || key">
                                                        <tr>
                                                            <td class="text-center">{{ (index * 100) + key + 1 }}</td>
                                                            <td>{{ check.field_name || '' }}</td>
                                                            <td>{{ check.field_type || '' }}</td>
                                                            <td>{{ check.default_value || '' }}</td>
                                                            <td>{{ check.is_required == 1 ? 'Yes' : 'No' }}</td>
                                                            <td>{{ check.field_values || '' }}</td>
                                                            <td>{{ check.lcl ?? '' }}</td>
                                                            <td>{{ check.ucl ?? '' }}</td>
                                                            <td>{{ check.value || '' }}</td>
                                                            <td>{{ check.check_remark || '' }}</td>
                                                        </tr>
                                                        <tr v-if="check && Array.isArray(check.check_attachments) && check.check_attachments.some(a => a?.type === 'image')">
                                                            <td colspan="10">
                                                                <div class="d-flex flex-wrap gap-3">
                                                                    <div
                                                                        v-for="(img, imgIndex) in check.check_attachments.filter(a => a?.type === 'image')"
                                                                        :key="'img-' + key + '-' + imgIndex"
                                                                        style="width: 120px;"
                                                                    >
                                                                        <a :href="$store.state.apiUrl + 'downloadCheckAttachment?file_name=' + (img.file_name || '')" target="_blank">
                                                                            <img
                                                                                :src="img.attachments || ''"
                                                                                class="img-fluid"
                                                                                alt="Image"
                                                                                style="width: 120px; height: 120px; object-fit: cover; border: 1px solid #ddd;"
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="check && Array.isArray(check.check_attachments) && check.check_attachments.some(a => a?.type === 'audio')">
                                                            <td colspan="10">
                                                                <div class="d-flex flex-wrap gap-3">
                                                                    <div
                                                                        v-for="(audio, audioIndex) in check.check_attachments.filter(a => a?.type === 'audio')"
                                                                        :key="'audio-' + key + '-' + audioIndex"
                                                                        style="width: 200px;"
                                                                    >
                                                                        <a :href="$store.state.apiUrl + 'downloadCheckAttachment?file_name=' + (audio.file_name || '')" target="_blank">
                                                                            <div style="padding: 5px; background-color: #f4f4f4; border: 1px solid #ddd;">
                                                                                <audio :src="audio.attachments || ''" controls style="width: 100%;"></audio>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="check && Array.isArray(check.check_attachments) && check.check_attachments.some(a => a?.type === 'video')">
                                                            <td colspan="10">
                                                                <div class="d-flex flex-wrap gap-3">
                                                                    <div
                                                                        v-for="(video, videoIndex) in check.check_attachments.filter(a => a?.type === 'video')"
                                                                        :key="'video-' + key + '-' + videoIndex"
                                                                        style="width: 200px;"
                                                                    >
                                                                        <a :href="$store.state.apiUrl + 'downloadCheckAttachment?file_name=' + (video.file_name || '')" target="_blank">
                                                                            <div style="padding: 5px; background-color: #f4f4f4; border: 1px solid #ddd;">
                                                                                <video :src="video.attachments || ''" controls style="width: 100%; height: 150px; object-fit: cover;"></video>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="text-center">
                                        <p>No asset checks available.</p>
                                    </div>
                                </div>
                            </div>
                            <!-- Image Attachments -->
                            <h6>Attachments:</h6>
                            <div class="d-flex flex-wrap mb-3">
                                <div
                                    class="imageContainer"
                                    v-for="(img, key) in user_check.user_attachments"
                                    :key="'img-' + key"
                                    style="width: 120px;"
                                >
                                    <div v-if="img && img.type === 'image'">
                                        <a :href="$store.state.apiUrl + 'downloadCheckAttachment?file_name=' + (img.file_name || '')" target="_blank">
                                            <img
                                                :src="img.attachments || ''"
                                                class="img-fluid"
                                                alt="Image"
                                                style="width: 120px; height: 120px; object-fit: cover;"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "ViewAsset",
    data() {
        return {
            user_check: {
                user_check_id: "",
                asset_id: "",
                reference_no: "",
                reference_date: "",
                note: "",
                status: "",
                asset_checks: [],
                asset: {},
                user_attachments: [],
            },
            errors: [],
        };
    },
    computed: {
        groupedChecks() {
            const grouped = {};
            grouped["no-frequency"] = {
                frequency_name: null,
                checks: [],
            };
            (this.user_check.asset_checks || []).forEach((check, index) => {
                if (!check || !check.check_id) {
                    console.warn(`Invalid check at index ${index}:`, check);
                    return;
                }
                const frequency_id = check.check_frequencies?.frequency_id || "no-frequency";
                if (!grouped[frequency_id]) {
                    grouped[frequency_id] = {
                        frequency_name: check.check_frequencies?.frequency_name || null,
                        checks: [],
                    };
                }
                grouped[frequency_id].checks.push(check);
            });

            const sortedGroups = {};
            Object.keys(grouped)
                .sort((a, b) => {
                    if (a === "no-frequency") return 1;
                    if (b === "no-frequency") return -1;
                    return a - b;
                })
                .forEach((key) => {
                    if (grouped[key].checks.length > 0) {
                        sortedGroups[key] = grouped[key];
                    }
                });

            return sortedGroups;
        },
        frequencyNames() {
            const frequencies = [];
            const seen = new Set();
            (this.user_check.asset_checks || []).forEach((check) => {
                if (check.check_frequencies?.frequency_name && !seen.has(check.check_frequencies.frequency_id)) {
                    frequencies.push(check.check_frequencies.frequency_name);
                    seen.add(check.check_frequencies.frequency_id);
                }
            });
            return frequencies.join(", ");
        },
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.user_check.user_check_id = to.params.user_check_id;
            vm.getUserCheck();
        });
    },
    methods: {
        getUserCheck() {
            let vm = this;
            let loader = vm.$loading.show();
            let uri = { uri: "getUserCheck", data: { user_check_id: vm.user_check.user_check_id } };
            vm.$store
                .dispatch("post", uri)
                .then(function (response) {
                    loader.hide();
                    if (!response || !response.data || !response.data.data) {
                        vm.$store.dispatch("error", "Invalid response from server. Please try again.");
                        console.error("Invalid response:", response);
                        return;
                    }
                    vm.user_check = {
                        ...response.data.data,
                        asset: response.data.data.asset || {},
                        asset_checks: response.data.data.asset_checks || [],
                        user_attachments: response.data.data.user_attachments || [],
                    };

                    vm.user_check.asset_checks = (vm.user_check.asset_checks || []).map((check, index) => {
                        if (!check) {
                            console.warn(`Null check at index ${index}:`, check);
                            return null;
                        }
                        return {
                            ...check,
                            check_id: check.check_id || `temp-${index}`,
                            field_name: check.field_name || "",
                            field_type: check.field_type || "",
                            default_value: check.default_value || "",
                            is_required: check.is_required || 0,
                            field_values: check.field_values || "",
                            lcl: check.lcl !== null && check.lcl !== undefined ? check.lcl : null,
                            ucl: check.ucl !== null && check.ucl !== undefined ? check.ucl : null,
                            value: check.value || "",
                            check_remark: check.check_remark || "",
                            check_frequencies: check.check_frequencies || {},
                            check_attachments: Array.isArray(check.check_attachments) ? check.check_attachments : [],
                        };
                    }).filter(check => check !== null);
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response?.data?.errors || { general: ["Failed to load user check data."] };
                    vm.$store.dispatch("error", error.response?.data?.message || "Failed to load user check data.");
                    console.error("Error fetching user check:", error);
                });
        },
        showImage(image) {
            const imageElement = document.getElementById("image");
            const btnElement = document.getElementById("btnID");
            if (imageElement && btnElement) {
                imageElement.style.display = "block";
                btnElement.style.display = "none";
            } else {
                console.warn("Element with ID 'image' or 'btnID' not found.");
            }
        },
        downloadImage(image) {
            if (image) {
                window.open(this.$store.state.apiUrl + "downloadCheckAttachment?file_name=" + image);
            } else {
                this.$store.dispatch("error", "Invalid image file name.");
            }
        },
        downloadEngineeringDetail() {
            let vm = this;
            vm.errors = [];
            if (!vm.engineering?.project_id) {
                vm.errors.project_id = ["The project field is required."];
            }
            if (!vm.engineering?.to_date) {
                vm.errors.to_date = ["The To Date field is required."];
            }
            if (vm.engineering?.project_id && vm.engineering?.to_date) {
                window.open(
                    vm.$store.getters.apiUrl +
                        "downloadElectricalDetailReport?project_id=" +
                        vm.engineering.project_id +
                        "&to_date=" +
                        vm.engineering.to_date +
                        "&from_date=" +
                        vm.engineering.from_date +
                        "&isDownload=true"
                );
            }
        },
        convertDateFormat(date) {
            return date ? moment(date).format("YYYY-MM-DD") : "";
        },
    },
};
</script>

<style scoped>
.font {
    font-size: 14px;
}
.setting-item .table th:not(:first-child),
.setting-item .table td:not(:first-child) {
    text-align: left;
}
.imageContainer {
    overflow: hidden;
}
.img {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
}
.imageContainer > img:hover {
    -webkit-transform: scale(1.3);
    transform: scale(1.3);
}
.d-flex {
    display: flex;
}
.flex-wrap {
    flex-wrap: wrap;
}
.mb-3 {
    margin-bottom: 1rem;
}
.mb-2 {
    margin-bottom: 0.5rem;
}
.frequency-header {
    background-color: #f8f9fa;
    font-weight: bold;
}
</style>